<template>
	<div>
  <div id="userCenter">
  	<!--<BottomMenu></BottomMenu>-->
		<section class="header-content">
			<p>
				<strong class="userphone">{{username}}</strong>
				<router-link to="/UserCenter/personalData" class="editinfo">编辑个人信息 <i class="arrow"><img src="../../../static/images/arrow.png"/></i></router-link>
			</p>
		</section>
    <div class="bgcontent mt10">
    	<div @click="orderQuery(0)">
	    	<mt-cell title="全部订单" is-link>
				  <img slot="icon" src="../../../static/images/order_ico.png" width="24">
				</mt-cell>
			</div>
			<ul class="order_box">
				<li @click="orderQuery(1)">
					<p class="text-center"><span class="position-relative display-inline"><img src="../../../static/images/topay_ico.png" width="45"/><i class="pay_num" :class="waitNum>10?'maxpay_num':''" v-show="waitNum!=0">{{waitNum>10?'10+':waitNum}}</i></span></p>
					<p class="text-center">待付款</p>
				</li>
				<li @click="orderQuery(2)">
					<p class="text-center"><span class="position-relative display-inline"><img src="../../../static/images/trading_ico.png" width="45"/><i class="pay_num" :class="successNum>10?'maxpay_num':''" v-show="successNum!=0">{{successNum>10?'10+':successNum}}</i></span></p>
					<p class="text-center">交易中</p>
				</li>
				<li class="border-right0" @click="orderQuery(3)">
					<p class="text-center"><span class="position-relative display-inline"><img src="../../../static/images/delivery_ico.png" width="45"/><i class="pay_num" :class="shipmentNum>10?'maxpay_num':''" v-show="shipmentNum!=0">{{shipmentNum>10?'10+':shipmentNum}}</i></span></p>
					<p class="text-center">待发货</p>
				</li>
				<li @click="orderQuery(4)">
					<p class="text-center"><span class="position-relative display-inline"><img src="../../../static/images/todelivery_ico.png" width="45"/><i class="pay_num" :class="takeNum>10?'maxpay_num':''" v-show="takeNum!=0">{{takeNum>10?'10+':takeNum}}</i></span></p>
					<p class="text-center">待收货</p>
				</li>
				<li @click="orderQuery(5)">
					<p class="text-center"><img src="../../../static/images/successful_ico.png" width="45"/></p>
					<p class="text-center">交易成功</p>
				</li>
				<li class="border-right0" @click="orderQuery(6)">
					<p class="text-center"><img src="../../../static/images/tradingoff_ico.png" width="45"/></p>
					<p class="text-center">交易关闭</p>
				</li>
			</ul>
   </div>
    <div class="bgcontent mt5">
    	<!--to="/UserCenter/manageAddress" -->
    		<mt-cell title="优惠券" to='/Ticket/ticket' is-link class="border-bottom-line" >
				  <img slot="icon" src="../../../static/images/prize.png" width="24">
			</mt-cell>
    		<div @click="toManage">
	    		<mt-cell title="地址管理" is-link class="border-bottom-line" >
				  <img slot="icon" src="../../../static/images/address_ico.png" width="24">
				</mt-cell>
			</div>
			<mt-cell title="修改登录密码" to="/UserCenter/modifyPassword" is-link class="border-bottom-line">
			  <img slot="icon" src="../../../static/images/change_key.png" width="24" >
			</mt-cell>
			<mt-cell title="关于我们" to="/UserCenter/aboutUs" is-link class="border-bottom-line">
			  <img slot="icon" src="../../../static/images/about_ico.png" width="24" >
			</mt-cell>
			<mt-cell title="意见反馈" to="/UserCenter/feedBack" is-link>
			  <img slot="icon" src="../../../static/images/feedback_ico.png" width="24">
			</mt-cell>
    </div>
  </div>
  <BottomMenu></BottomMenu>
  </div>
</template>

<script>
	import BottomMenu from '@/components/BottomMenu'
	export default{
		components:{
			BottomMenu,
		},
		data(){
			return{
			  username:localStorage.getItem("username"), //用户名
			  waitNum:"",//待付款角标
			  successNum:"",//支付成功角标
			  shipmentNum:"",//待发货角标
			  takeNum:"",//待收货数
			  sign:'center',//跳到地址管理的标志
			}
		},
		created:function(){
			this.queryNum();
	  },
	  methods:{
	  	//跳到地址管理页面
	  	toManage(){
	  		localStorage.setItem("sign",this.sign);
	  		this.$router.push("/UserCenter/manageAddress");
	  	},
	  	//点击进入相应的订单状态列表
	  	orderQuery(status){
	  		this.$router.push({path: "/Order/orderList",query:{state:status}});
	  	},
	  	//获取订单角标数据
	  	queryNum(){
	    	this.$http.post(this.URL_PREFIX+"/order/findOrderNum.net",{phone:this.username})
	  	  .then((res) =>{
	  	  	//console.log(res);
	  	  	this.waitNum=res.data.obj.wait;//待付款角标
	  	  	this.successNum=res.data.obj.success;//支付成功角标
	  	  	this.shipmentNum=res.data.obj.shipment;//待发货角标
	  	  	this.takeNum=res.data.obj.take;  //待收货角标
	  	  });
	   }
	  }
	}
</script>

<style scoped="scoped">
#userCenter{width: 100%;
    position: absolute;
    top: 0px;
    left: 0;
    bottom: 56px;
    overflow: auto;}
.mint-header{background: #ff8920;}
.arrow img{width: 10%;position: relative;top: 2px;}
.bgcontent{width: 100%;background: #fff;display: inline-block;overflow: hidden;}
.header-content{background-color: #ff8920;padding: 35px 0 35px 0;overflow: hidden;}
.editinfo{color:#fff;float: right;text-align: center;margin-top: 6px;font-size: 0.9rem;}
.order_box{border-top:1px solid #d6d6d6;}
.order_box li{float: left;width: 33%;border-right:1px solid #eee;border-bottom:1px solid #eee;padding: 10px 0;color: #666;font-size: 0.8rem;}
.order_box li.border-right0{border-right: none;}
.userphone{color: #333;background: #ffd634;display: inline-block;float: left;padding:4px 20px 4px 10px;border-radius: 0 20px 20px 0;-webkit-border-radius:0 20px 20px 0;font-size: 1.0rem;}
.pay_num{background: #ff5513;width: 15px;height: 15px; line-height: 15px;padding:1px;color:#fff;font-size: 0.7rem; position: absolute;top: 0px;right:-10px;border-radius: 100%;-webkit-border-radius: 100%;}
.maxpay_num{width: 25px;border-radius: 50px;-webkit-border-radius:50px;}
</style>    


// WEBPACK FOOTER //
// src/views/UserCenter/index.vue